import styles from "./Angebote.module.css";
import AngeboteKarte from "./AngeboteKarte/AngeboteKarte.jsx";

function Angebote({ title, body }) {
  return (
    <>
      <div className={styles.cardsWrapper}>
        <div className={styles.cardsContainer}>
          <AngeboteKarte
            title="Griechisch"
            price="55"
            body="Authentische griechische Klassiker mit frischen Vorspeisen, herzhaften Spezialitäten und mediterranen Aromen."
            pdf="assets/Angebote/Menue_griechisch.pdf"
          />
          <AngeboteKarte
            title="Mediterran"
            price="65€"
            body="Mediterrane Leichtigkeit trifft auf internationale Klassiker – frisch, aromatisch und vielseitig."
            pdf="assets/Angebote/Menue_mediterran.pdf"
          />
        </div>
      </div>
      <a href="/kontakt" className={styles.contactLink}>
        Kontakt aufnehmen
      </a>
    </>
  );
}

export default Angebote;
